import { ChevronLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getGalleryImageSrc } from './cityUtils';

export default function CityScreen({
  context,
  cityTypeLabel,
  title,
  subtitle,
  showBackToCity = true,
  backLinkLabel = 'Volver a Ciudad',
  backLinkTarget = '/city',
  showDashboardLink = true,
  children
}) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#04060d] text-slate-100">
      <div className="max-w-7xl mx-auto px-4 py-8 space-y-5">
        <div className="flex items-center gap-3">
          {showBackToCity && (
            <button
              onClick={() => navigate(backLinkTarget)}
              className="inline-flex items-center gap-2 text-cyan-300 hover:text-cyan-200"
            >
              <ChevronLeft size={16} /> {backLinkLabel}
            </button>
          )}
          {showDashboardLink && (
            <button
              onClick={() => navigate('/dashboard')}
              className="inline-flex items-center gap-2 text-slate-300 hover:text-slate-100"
            >
              <Home size={15} /> Dashboard
            </button>
          )}
        </div>

        <div
          className="rounded-2xl border border-cyan-500/30 shadow-[0_0_40px_rgba(0,255,255,0.12)] p-5 bg-cover bg-center relative overflow-hidden"
          style={{
            backgroundImage: context.city && getGalleryImageSrc(context.city)
              ? `url(${getGalleryImageSrc(context.city)})`
              : 'linear-gradient(to bottom, #091225, #060a14)'
          }}
        >
          <div className="absolute inset-0 bg-[#030813]/80" />
          <div className="relative z-10">
            <h1 className="text-4xl font-bold tracking-wide text-cyan-300">
              {title}
            </h1>
            <p className="mt-1 text-sm text-slate-200/90">{subtitle}</p>
            {context.city && (
              <div className="mt-2 text-sm text-slate-300/90 space-y-1">
                <div>Tipo: <span className="text-cyan-200 font-bold">{cityTypeLabel}</span> | Clan dominante: <span className="text-cyan-200 font-bold">{context.city.clan_name || 'Neutral'}</span></div>
                <div>Sector: <span className="text-cyan-200 font-bold">{context.city.sector_name || `#${context.bot?.id_sector ?? 'N/A'}`}</span> | Coordenada: <span className="text-cyan-200 font-bold">{context.bot?.coordinate ?? 0}</span></div>
              </div>
            )}
          </div>
        </div>

        {children}
      </div>
    </div>
  );
}
